/**
 *
 * InboxesSwitch
 *
 */

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useApi2, useApi2call } from 'containers/Api2/index.js';
import useCurrentRole from 'containers/User/useCurrentRole.js';
import ExplicitRemoveModal from 'components/interaction/ExplicitRemoveModal/index.jsx';
import cx from 'utils/cx.js';
import { intlTags } from 'utils/intlFunctions.jsx';
import classInbox from './class-inbox.png';
import messages from './messages.js';
import InboxStatus, { INBOX_ACTIVE, INBOX_INACTIVE, INBOX_ARCHIVED } from '../Users/InboxStatus.jsx';

function InboxesSwitch(props) {
  const { className } = props;
  const { school } = useCurrentRole();
  const { enabled, status } = useApi2({ url: `sa/schools/${school.id}/groupinboxes`, version: 2, ignore: [405] });
  const api2call = useApi2call();
  const [show, setShow] = useState(false);
  const derivedStatus = useMemo(() => {
    if (status) {
      return status;
    }
    return enabled ? INBOX_ACTIVE : INBOX_INACTIVE;
  }, [enabled, status]);

  function updateStatus(newStatus) {
    api2call({
      url: `sa/schools/${school.id}/groupinboxes`,
      method: 'PUT',
      version: 2,
      body: { enabled: newStatus === INBOX_ACTIVE, status: newStatus },
    });
  }

  function handleChange(newStatus) {
    if (newStatus !== INBOX_ARCHIVED) {
      updateStatus(newStatus);
      return;
    }
    setShow(true);
  }

  function handleArchive() {
    updateStatus(INBOX_ARCHIVED);
    setShow(false);
  }

  return (
    <Card className={cx('border', className)}>
      <Card.Body className="d-flex align-items-center">
        <img src={classInbox} alt="Class inbox" width="42" height="40" />
        <div className="flex-grow-1 mx-3">
          <h3 className="fs-6"><FormattedMessage {...messages.classInbox} /></h3>
          <FormattedMessage {...messages.classInboxIntro} />
        </div>
        <InboxStatus value={derivedStatus} onChange={handleChange} />
      </Card.Body>
      <ExplicitRemoveModal
        show={show}
        title={messages.confirmArchiveClassModalTitle}
        onHide={() => setShow(false)}
        onSubmit={handleArchive}
        confirmMessage={messages.doArchive}
      >
        <FormattedMessage {...messages.confirmArchiveClassModalIntro} />
        <FormattedMessage {...messages.archivedClassInboxRules} values={intlTags(['li', 'ul'])} />
      </ExplicitRemoveModal>
    </Card>
  );
}

InboxesSwitch.propTypes = {
  onChange: PropTypes.func,
  schoolRole: PropTypes.object,
  className: PropTypes.string,
};

export default InboxesSwitch;
